/* eslint-disable max-len */
import { CalendarBlankIcon } from '@/shared/dynamicImports';
import { colorAccent, colorFieldsBorder, colorText } from '@/utils/palette';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled from 'styled-components';
import { DatePickerWrap } from './DatePickerElements';
import { formatDate } from './utils';

const DateTimePickerField = React.memo(
  ({ name, label = 'Select Date Time', defaultValue, onChange, error, dateOutputFormat = 'format1', helperText }) => {
    const [selectedDateTime, setSelectedDateTime] = useState(
      defaultValue ? new Date(convertToCorrectInputFormat(defaultValue)) : null,
    );
    const [calendarOpen, setCalendarOpen] = useState(false);

    function convertToCorrectInputFormat(dateString) {
      // Check if the date is in the format YYYY-MM-DDTHH:mm:ss.sssZ
      const isValidISOFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(dateString);

      if (isValidISOFormat) {
        // Extract the date part and append T08:00
        const datePart = dateString.split('T'); // Extract the date before "T"
        return `${datePart[0]}T${datePart[1][0]}${datePart[1][1]}:${datePart[1][3]}${datePart[1][4]}`; // Append "T08:00"
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        // If in YYYY-MM-DD format, append "T08:00"
        return `${dateString}T08:00`; // Append "T08:00"
      } else {
        return dateString;
      }
    }

    // to avoid time correction which adds gmt +8 because we are selecting time from the picker
    const convertToUTC = (dateString) => {
      const localDate = new Date(dateString);

      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, '0');
      const day = String(localDate.getDate()).padStart(2, '0');
      const hours = String(localDate.getHours()).padStart(2, '0');
      const minutes = String(localDate.getMinutes()).padStart(2, '0');
      const seconds = String(localDate.getSeconds()).padStart(2, '0');
      const milliseconds = String(localDate.getMilliseconds()).padStart(3, '0');

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
    };

    const handleChange = (dateString) => {
      let gmtZeroDateString = convertToUTC(dateString);
      let formattedDate = formatDate(gmtZeroDateString, dateOutputFormat);
      setSelectedDateTime(dateString);
      onChange(formattedDate);
    };

    const handleCalendarIconClick = () => {
      setCalendarOpen((prevState) => !prevState);
    };

    const handleDatePickerClick = () => {
      setCalendarOpen(true);
    };

    return (
      <div>
        {label && <Label error={error}>{label}</Label>}
        <div style={{ display: 'flex' }}>
          <DatePickerWrap>
            <StyledDatePicker
              name={name}
              selected={selectedDateTime}
              onChange={handleChange}
              dateFormat='MM/dd/yyyy hh:mm aa'
              showTimeSelect
              open={calendarOpen}
              onClickOutside={() => setCalendarOpen(false)}
              onClick={handleDatePickerClick}
              onFocus={handleDatePickerClick}
            />
          </DatePickerWrap>

          <StyledCalendarIcon onClick={handleCalendarIconClick} />
        </div>
        {helperText && <HelperText>{helperText}</HelperText>}
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>
    );
  },
);

DateTimePickerField.displayName = 'DateTimePickerField';

export default DateTimePickerField;

const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-bottom: 20px;
  font-size: 12px;
`;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const StyledCalendarIcon = styled(CalendarBlankIcon)`
  cursor: pointer;
  font-size: 16px;
  color: #6c757d;
  border: 1px solid ${colorFieldsBorder};
  border-radius: 2px;
  height: 32px;
  padding: 2px;
`;

const StyledDatePicker = styled(DatePicker)`
  outline: none;
  // width: 100%;
  // height: 28px;
  padding: 2px 12px;
  font-size: 12px;
  border: 1px solid ${colorFieldsBorder};
  border-radius: 2px;
  background-color: transparent !important;
  color: ${colorText};

  // &:focus {
  //   outline: none;
  //   border-color: ${colorAccent} !important;
  // }

  // &::placeholder {
  //   color: #999;
  // }

  // .react-datepicker__input-container {
  //   width: 100%;
  // }

  // .react-datepicker__day--selected,
  // .react-datepicker__day--keyboard-selected {
  //   background-color: ${colorAccent} !important;
  //   color: #fff;
  // }

  // .react-datepicker__header {
  //   background-color: #f8f9fa;
  //   border-bottom: 1px solid #e9ecef;
  // }

  // .react-datepicker__day {
  //   &:hover {
  //     background-color: ${colorAccent} !important;
  //     color: #fff;
  //   }
  }

  // .react-datepicker__close-icon {
  //   background-color: transparent;
  //   &:after {
  //     background-color: ${colorAccent} !important;
  //     color: white;
  //     border-radius: 50%;
  //   }
  // }
`;
